function update_query_parameters(key, val) {
   uri = window.location.href
      .replace(RegExp("([?&]"+key+"(?=[=&#]|$)[^#&]*|(?=#|$))"), "&"+key+"="+encodeURIComponent(val))
      .replace(/^([^?&]+)&/, "$1?");
   return uri;
}
                                               
jQuery(document).ready(function() {
  
  
  	const params = new URLSearchParams(window.location.search);
  	const current_url = window.location.href;
  	let store_location = "";
  
    if("store_location" in localStorage && localStorage["store_location"] != "") {
      store_location = localStorage["store_location"];
      jQuery("a[href*='/collections/']").each(function(){
          let original_url = jQuery(this).attr("href");
          jQuery(this).attr("href", original_url + "?pf_l_locations=" + store_location);
      });
    }
  
    if("store_location" in localStorage && localStorage["store_location"] != "" && !params.has("pf_l_locations") && current_url.indexOf("/collections/") >= 0 ) {		
      	window.location.href = update_query_parameters('pf_l_locations', store_location);
    }
  
  	if(params.has("pf_l_locations") && params.get("pf_l_locations") != store_location && current_url.indexOf("/collections/") >= 0 ) {		
      	window.location.href = update_query_parameters('pf_l_locations', store_location);
    }
  
    jQuery(document).on("click", ".boost-pfs-filter-clear", function(){
      if(jQuery(this).attr("aria-label") == "Clear filter by Locations " + store_location) {
      	localStorage.removeItem('store_location');
      }
    });
  
  
  	jQuery(document).on("click", '[js-quick-add]', function() {
		var variantId = $(this).data('variant');
      // var productTags = $(this).data('tags');
      var productTags = $(this).data('tags').split(', ');
      const _genderTags = productTags.filter(t => t.substring(0,2) === 'g_')?.map(t => t.split('g_')[1]);
      const _styleGroup = productTags.find(t => t.substring(0,4) === 'stg_')?.split('stg_')[1];
      const _styleDescripton = productTags.find(t => t.substring(0,4) === 'std_')?.split('std_')[1];
      const _colorFamily = productTags.find(t => t.substring(0,3) === 'cf_')?.split('cf_')[1];
      const _label = productTags.find(t => t.substring(0,4) === 'lbl_')?.split('lbl_')[1];
      const _category = productTags.find(t => t.substring(0,4) === 'cat_')?.split('cat_')[1];
      
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({
          id: variantId,
          quantity:1,
          properties: {
            // __productTags: productTags.split(', ')
            _genderTags,
            _styleGroup,
            _styleDescripton,
            _colorFamily,
            _label,
            _category
          }
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      });
	});
  
  
//     jQuery(".variant__option-label").click(function(evt) {
//     	var handle = jQuery(this).prev("input").val();
//       let productSingleObject = JSON.parse(jQuery("[data-product-json]", jQuery(this).closest("form")).html());

//       if (productSingleObject.handle === handle) {
//         return;
//       }

//       window.location = '/products/' + handle;
//     });
  
  
    // if (jQuery(".product-single__sku").length > 0 ) {
    //     let sku = jQuery(".product-single__sku").text().replace(/\*+$/, "");
    //     let style = sku.substring(0, 7);
    //     let team = sku.substring(7, 10);
    //     let color = sku.substring(10, 13);
    //     // let arr = sku.split("***");
    //     // let col = arr[1];
    //     let str = "Style: " + style + " - " + "Color: " + color;
    //     jQuery(".product-single__sku").text(str);

    // }
  
  	var first_load = 1;

	// jQuery('.variant__button-label').on('click', function(){
 //        setTimeout(function(){
 //          let sku = jQuery(".product-single__sku").text().replace(/\*+$/, "");
 //          let style = sku.substring(0, 7);
 //          let team = sku.substring(7, 10);
 //          let color = sku.substring(10, 13);
 //          // let arr = sku.split("***");
 //          // let col = arr[1];
 //          let str = "Style: " + style + " - " + "Color: " + color;
 //          jQuery(".product-single__sku").text(str);
 //          first_load = 2;
 //        }, 20);
 //    });

  var time;
  
  jQuery("body").on('DOMSubtreeModified', "#boost-pfs-filter-tree2-pf-opt-size", function() {
      clearTimeout(time);
      time = setTimeout(function() {
        jQuery(".boost-pfs-filter-option-value").each(function() {
          jQuery(this).text(jQuery(this).text().replace(/_/g, " "));
          jQuery(this).text(jQuery(this).text().replace("No age breakdown", "No age"));
          jQuery(this).text(jQuery(this).text().replace("Adult | ", ""));
          // jQuery(this).text(jQuery(this).text().replace("Kid | ", ""));
          // jQuery(this).text(jQuery(this).text().replace("Youth | ", ""));
          // jQuery(this).text(jQuery(this).text().replace("Infant | ", ""));
          jQuery(this).text(jQuery(this).text().replace("XXXXXX", "6X"));
          jQuery(this).text(jQuery(this).text().replace("XXXXX", "5X"));
          jQuery(this).text(jQuery(this).text().replace("XXXX", "4X"));
          jQuery(this).text(jQuery(this).text().replace("XXX", "3X"));
          jQuery(this).text(jQuery(this).text().replace("XX", "2X"));
        });
      }, 500);
  });
});

jQuery(window).on("load", function(){
	setTimeout(function(){
      jQuery(".boost-pfs-filter-option-value").each(function() {
      	jQuery(this).text(jQuery(this).text().replace(/_/g, " "));
        jQuery(this).text(jQuery(this).text().replace("No age breakdown", "No age"));
        jQuery(this).text(jQuery(this).text().replace("Adult | ", ""));
        // jQuery(this).text(jQuery(this).text().replace("Kid | ", ""));
        // jQuery(this).text(jQuery(this).text().replace("Youth | ", ""));
        // jQuery(this).text(jQuery(this).text().replace("Infant | ", ""));
        jQuery(this).text(jQuery(this).text().replace("XXXXXX", "6X"));
        jQuery(this).text(jQuery(this).text().replace("XXXXX", "5X"));
        jQuery(this).text(jQuery(this).text().replace("XXXXX", "4X"));
        jQuery(this).text(jQuery(this).text().replace("XXX", "3X"));
        jQuery(this).text(jQuery(this).text().replace("XX", "2X"));
      });
    }, 500);
  
  
//   	jQuery(".product-slideshow-slick.hide").removeClass("hide");
  
});